export default "__VITE_ASSET__705909f9__"